import React, { Component } from 'react';
//import PropTypes from 'prop-types';
//import { Theme } from '@mui/material/styles';

import AccountPanel from './AccountPanel';
import {BaseCard} from '../../../components/wizard';
//import { extendedstyles } from '../../appstyles';
import { bizpost } from '../../../ajax';

const s:any ={
  // root: {
  //   width: '100%',
  //   display: 'flex',
  //   // overflow: 'scroll',
  //   justifyContent: 'space-between'
  // },
  // panel: {
  //   flex: '1 1 auto'
  // },
};

class AccountCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("AccountCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false,
      loading:false,
      account: {},
    };
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  //this method is designed for basecard.handleSend
  doSubmit = async() => {
    const { classes, theme, showNotification, ...extraProps } = this.props;  //fmtUI, logo, title, switchFn,
    const { record,data,extras,setItem } = this.props;
    const {data:formdata} = data;

    try{
      this.startLoading();
      
      const s = 'bankapi';
      const a = 'account';
      const params = {...record,...formdata,s,a};
      console.log('service request ',params);
      var response = await bizpost(params);
      //console.log('service response ',response);
      const {success,data:resdata} = response;

      if (success){
        showNotification(response.sm,'success',response.st)
        //onResponse(true,response);
        // "data": {
        //   "account": "0011020001003351",
        //   "title": "Samuel Kwame Torgbor",
        //   "currency": "GHS",
        //   "company": "GH0010001",
        //   "balance": "0",
        //   "type": "Cu",
        //   "actualbalance": "0",
        //   "product": "2"
        // },
        const {title:nam,currency:cur,type:atc,balance:bal} = resdata;
        console.log('found: ',nam,cur,bal,atc,data);
        const {data:olddata} = data;
        const newdata = {...olddata,nam};
        setItem('data','data',newdata);
        //this.setState({account:data});
        return response;
      }
      else if(response.failure){
        if (response.en===60){
        }
        else{
          showNotification(response.message,response.type||'error',response.title);
          return Promise.reject(response);
        }
      }      
    }
    catch(err){
      const error:any = err || {};
      console.log('submit.error:',JSON.stringify(error));
      showNotification(error.message||"request failed",error.type||'warn',error.title||'Update Error');
      return Promise.reject(response);
    }
    finally{
      this.stopLoading();
    }
      
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,setItem} = this.props;
    const {loading} = this.state;
    const {account} = data.start;
    return (
      <BaseCard
        cardid={'ACOUNT'}
        cardname={'Account'}
        cardtitle={'Account Information'}
        instruction={'Provide service account information of the customer'}
        step={1}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        doSubmit={this.doSubmit.bind(this)}
        {...extraProps}
        minHeight={300}
      >
        <AccountPanel 
          data={extraProps.data}
          record={record}
          extras={extras}
          loading={loading}
          account={account} 
          //idcard={idcard}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

AccountCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default AccountCard;
